module.exports = __webpack_public_path__ + "static/media/success_payment.232fb05f.svg";